'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/~/dom-scroll-into-view/lib/index.js
// module id = 2067
// module chunks = 0